import { alpha } from '@mui/material/styles';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
  root: {
    borderRadius: 6,
    background: theme.palette.background.paper,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  actionSection: {
    display: 'flex',
    gridColumn: '1/3',
    gridRow: '3',
    padding: `${theme.spacing(2)} ${theme.spacing(2)} ${theme.spacing(3)}`,
    borderTop: `1px solid ${theme.palette.border.light}`,
    justifyContent: 'space-between',
  },
  buttonSection: {
    '& > button + button': {
      marginLeft: theme.spacing(2),
    },
  },
  actionButtons: {
    padding: `0px ${theme.spacing(3)}`,
  },
  defaultSection: {
    display: 'flex',
    alignItems: 'center',
    '& > p + div': {
      marginLeft: theme.spacing(1),
    },
  },
  toolbarSection: {
    display: 'flex',
    gridColumn: '2/3',
    gridRow: '1',
    padding: theme.spacing(2),
  },
  datesContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'baseline',
    '& > div + div': {
      marginLeft: theme.spacing(3),
    },
    margin: theme.spacing(2),
    '& .MuiTextField-root': {
      flex: 1,
      width: 224,
      '&>.MuiInputBase-root': {
        height: 48,
        borderRadius: theme.spacing(1),
      },
    },
  },
  dateRangeType: {
    color: theme.palette.text.secondary,
    alignSelf: 'center',
  },
  dateRangeContainer: {
    display: 'inline-flex',
    '& > .MuiButton-root + .MuiTypography-root': {
      marginLeft: theme.spacing(1.5),
    },
  },
  shortcutContainer: {
    gridColumn: 1,
    gridRow: 2,
    borderRight: `1px solid ${theme.palette.border.light}`,
    padding: `${theme.spacing(2)}`,
    '& [sharedcomponentid="Q_CHOICE_CHIPS"]': {
      gap: theme.spacing(0.5),
    },
    '& div': {
      display: 'flex',
      flexDirection: 'column',
    },
    '& .MuiChip-outlined': {
      border: 'none',
      alignItems: 'flex-start',
      margin: 0,
      borderRadius: '9px',
      fontSize: '16px',
      padding: '6px',
      height: 'auto',
    },
    '& .MuiChip-selected': {
      backgroundColor: theme.palette.primary.light,
      color: theme.palette.primary.main,
    },
  },
  staticDatePicker: {
    border: '10px solid',
  },
  datePickerPopover: {
    '.MuiChip-root': {
      flexGrow: 1,
      background: 'none',
      align: 'flex-start',
      justifyContent: 'flex-start',
      borderRadius: '6px',
      margin: 0,
    },
    '.MuiChip-label': {
      ...theme.typography.bodyRegular,
      lineHeight: theme.spacing(2.5),
    },
    '.MuiPickersArrowSwitcher-root': {
      paddingBottom: theme.spacing(2),
      paddingTop: 0,
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2),
    },
    '.MuiPickersSlideTransition-root': {
      minWidth: parseInt(theme.spacing(4), 10) + 224,
      minHeight: 200,
    },
    '.MuiDayCalendar-weekContainer': {
      margin: 0,
    },
    '.MuiDateRangePickerDay-rangeIntervalDayHighlight': {
      backgroundColor: alpha(theme.palette.primary.main, theme.palette.action.selectedOpacity),
      '&:not(:has(.Mui-selected)):not(:is(.MuiDateRangePickerDay-rangeIntervalDayPreview, .MuiDateRangePickerDay-rangeIntervalDayPreviewEnd, .MuiDateRangePickerDay-rangeIntervalDayPreviewStart))':
        {
          '&:last-of-type': {
            borderRadius: 0,
          },
          '&:first-of-type': {
            borderRadius: 0,
          },
        },
    },
    '.MuiDateRangePickerDay-rangeIntervalDayHighlightStart': {
      '& .MuiButtonBase-root': {
        borderTopRightRadius: 0,
        borderBottomRightRadius: 0,
      },
      '&.MuiDateRangePickerDay-rangeIntervalDayPreview': {
        borderRadius: 0,
      },
    },
    '.MuiDateRangePickerDay-rangeIntervalDayHighlightEnd': {
      '& .MuiButtonBase-root': {
        borderTopLeftRadius: 0,
        borderBottomLeftRadius: 0,
      },
      '&.MuiDateRangePickerDay-rangeIntervalDayPreview': {
        borderRadius: 0,
      },
    },
    '.MuiDateRangePickerDay-root': {
      width: 32,
      height: 32,
      '& .MuiDateRangePickerDay-rangeIntervalPreview': {
        border: 'none',
        width: '100%',
        height: '100%',
      },
    },
    '.MuiButtonBase-root.MuiPickersDay-root': {
      fontSize: '0.875rem',
      width: '100%',
      height: '100%',
      transform: 'none',
    },
    '.MuiDateRangePickerDay-hiddenDayFiller': {
      visibility: 'hidden',
    },
    '.MuiDateRangePickerDay-startOfMonth.MuiDateRangePickerDay-firstVisibleCell': {
      borderTopLeftRadius: '0px',
      borderBottomLeftRadius: '0px',
    },
    '.MuiDateRangePickerDay-endOfMonth.MuiDateRangePickerDay-lastVisibleCell': {
      borderTopRightRadius: '0px',
      borderBottomRightRadius: '0px',
    },
    '.Mui-selected': {
      borderRadius: '6px',
      fontWeight: 'unset',
    },
    '.MuiPickersDay-today': {
      borderWidth: 1,
      borderStyle: 'solid',
      borderColor: `${theme.palette.primary.main} !important`,
    },
    '.MuiDateRangePickerDay-rangeIntervalDayPreview': {
      '&:last-of-type': {
        borderColor: 'transparent',
        borderRadius: 0,
      },
      '&:first-of-type': {
        borderColor: 'transparent',
        borderRadius: 0,
      },
      borderColor: 'transparent',
      backgroundColor: alpha(theme.palette.primary.main, theme.palette.action.hoverOpacity),
      borderRadius: 0,
      '&.MuiDateRangePickerDay-rangeIntervalDayPreviewStart': {
        borderTopLeftRadius: 6,
        borderBottomLeftRadius: 6,
      },
      '&.MuiDateRangePickerDay-rangeIntervalDayPreviewEnd': {
        borderTopRightRadius: 6,
        borderBottomRightRadius: 6,
      },
    },
    '.MuiDateRangePickerDay-dayOutsideRangeInterval': {
      borderRadius: '6px',
      '&:not(.MuiPickersDay-today)': {
        borderColor: 'transparent !important',
      },
    },
    '.MuiSelect-select': {
      minWidth: '140px',
      color: theme.palette.text.primary,
    },
    '.MuiDateRangeCalendar-monthContainer:not(:last-of-type)': {
      borderRight: 'none',
    },
    '.MuiDateRangePickerDay-dayInsideRangeInterval': {
      opacity: 1,
    },
    '.MuiDayCalendar-weekDayLabel': {
      width: 32,
      height: 32,
      margin: 0,
    },
  },
  dynamicView: {
    '& .MuiFormControlLabel-root': {
      '& .MuiRadio-root': {
        padding: 3,
      },
      '&>.MuiTypography-root>.MuiBox-root': {
        paddingTop: 2,
      },
    },
  },
  selectedRangeInput: {
    border: `3px solid ${theme.palette.primary.main}`,
    borderRadius: '4px',
    backgroundColor: `${theme.palette.primary.light}`,
  },
  clearDateIcon: {
    fontSize: '16px !important',
  },
}));

export default useStyles;
